<template>
  <div class="archive-module">
    <b-row class="search-block  mb-3 mt-1">
      <b-col
        xl="4"
        lg="6"
        md="6"
        sm="6"
      >
        <searcher-module
          ref="searcherModule"
          name="archiveSearcher"
          :error-message="$tc('archive.error.validIdentifier')"
          is-general-disabled
          :default-search-type="'currentPage'"
          subportion-search
          portion-search
          sample-search
          @subportionSearch="onEntitySearch($event, COREENTITY_VALUES.SUBPORTION)"
          @portionSearch="onEntitySearch($event, COREENTITY_VALUES.PORTION)"
          @sampleSearch="onEntitySearch($event, COREENTITY_VALUES.SAMPLE)"
        />
      </b-col>
      <b-col
        xl="8"
        lg="6"
        md="6"
        sm="6"
        class="text-right"
      >
        <div style="margin-top: 5px;">
          <b-button
            v-testing="'add'"
            class="ml-2 btn btn--primary btn-secondary btn-sm"
            @click="$refs.archiveAddModalWizard.show()"
          >
            <fa-icon
              class="mr-1"
              :icon="['fal', 'plus']"
            />
            {{ $tc('archive.actions.archiveAddButton') }}
          </b-button>
        </div>
      </b-col>
    </b-row>

    <div class="grid-container">
      <GridHeader
        :gridtitle="sideBarSelectedOption && `${$t(sideBarSelectedOption.parentLabel)} - ${$t(sideBarSelectedOption.label)}`"
        :gridsubtitle="msgSelectedRows"
        :qa="`${sideBarSelectedOption.id}`"
      >
        <grid-display-options
          v-if="gridApi"
          :ui-component="displayOptionsUiComponent"
          @changedPageSize="changedPageSize($event)"
          @changedMode="changedMode($event)"
        />
        <div class="ml-2 pr-0 d-flex align-items-center">
          <!-- TODO Front: the following form is prepared for the new development, modified v-if with 'selectedRows.length', see UX document for more info -->
          <b-form-group
            v-if="false"
            class="barcode-input float-component mb-0 mr-2"
          >
            <b-input-group
              size="sm"
              class="mb-2 mr-sm-2 mb-sm-0"
            >
              <b-input-group-prepend class="h-100">
                <b-input-group-text>
                  <fa-icon :icon="['fal', 'barcode-alt']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <vt-input
                :placeholder="`${ $t('archive.grid.archiveLocation') }...`"
                size="sm"
              />
            </b-input-group>
          </b-form-group>
          <button
            v-if="!areElementsOfSelectedOptionArchived"
            v-testing="'archive'"
            v-tooltip="$t('archive.actions.archive')"
            :disabled="!selectedRows.length"
            class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
            type="button"
            @click="$refs.archiveAddModal.show(selectedRows)"
          >
            <i
              class="far fa-inbox-in"
              aria-hidden="true"
            />
          </button>
          <button
            v-else-if="areElementsOfSelectedOptionPendingUnarchiving"
            v-testing="'unarchive'"
            v-tooltip="$t('archive.actions.remove')"
            class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
            :disabled="!selectedRows.length"
            type="button"
            @click="unarchiveSelectedElements(selectedRows)"
          >
            <i
              class="far fa-inbox-out"
              aria-hidden="true"
            />
          </button>
          <button
            v-else-if="areElementsOfSelectedOptionArchivedAndNotPendingUnarchiving"
            v-testing="'take-out-from-laboratory'"
            v-tooltip="$t('archive.actions.takeOutFromLaboratory')"
            class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
            :disabled="!selectedRows.length"
            type="button"
            @click="takeOutFromLaboratorySelectedElements()"
          >
            <i
              class="far fa-inbox-out"
              aria-hidden="true"
            />
          </button>
        </div>
        <div class="pl-1 pr-0 d-flex align-items-center">
          <div class="vertical-line mx-2" />
        </div>
        <div class="pl-1 pr-0 d-flex align-items-center">
          <button
            id="samplesCleanFilters"
            v-testing="'clean'"
            v-tooltip="$t('global.cleanFilter')"
            v-shortkey="['ctrl', 'alt', 'f']"
            class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
            type="button"
            @shortkey.prevent="cleanFilters"
            @click="cleanFilters"
          >
            <i
              class="far fa-filter"
              aria-hidden="true"
            />
          </button>
        </div>

        <vt-report-export-buttons
          source="archive-grid"
          :export-report="exportReport"
        />
      </GridHeader>
      <archive-location-sidepanel
        v-if="sidePanel"
        @closeArchiveLocationSidepanel="closeArchiveLocationSidepanel"
      />
      <vt-grid
        ref="vtGrid"
        :key="`${rowModel}-${sideBarSelectedOption.id}`"
        v-testing="'elements'"
        class="archive-grid"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :component-code="uiComponent"
        autosize-columns
      />
    </div>
    <take-out-from-laboratory-modal
      ref="takeOutFromLaboratoryModal"
      :entity-type="entityType"
      :entity-subtype="optionEntitySubtype"
      @elements-taken-out-from-laboratory="onElementsTakenOutFromLaboratory($event)"
    />
    <archive-add-modal
      ref="archiveAddModalWizard"
      wizard-mode-enabled
      :laboratory-id="laboratoryId"
      @archived="onArchived"
    />
    <archive-add-modal
      ref="archiveAddModal"
      :laboratory-id="laboratoryId"
      :entity-type="entityType"
      :entity-subtype="optionEntitySubtype"
      @archived="onArchived"
    />
    <modal-confirmation
      id="archiveOptionChangeConfirmationModal"
      ref="archiveOptionChangeConfirmationModal"
      :content="$t('archive.search.optionChangeConfirmation')"
    />
    <modal-wrapper ref="scanLocationModalWrapper">
      <scan-location-modal
        ref="scanLocationModal"
        :entity-type="entityType"
        :entity-subtype="optionEntitySubtype"
        @archiving-location-updated="onLocationUpdated"
      />
    </modal-wrapper>
    <modal-confirmation-checkable
      id="takeOutFromLaboratoryConfirmation"
      ref="takeOutFromLaboratoryConfirmation"
      v-testing="'element-already-pending-confirmation-modal'"
      :content="$t('archive.modal.takeOutFromLaboratoryMessage', { coreEntity: 'La muestra', entityLabel: nextElementToConfirmTakeOut.label, reason: nextElementToConfirmTakeOut.pendingUnarchivingReason })"
      :checkable="$t('archive.modal.takeOutFromLaboratoryCheckboxMessage')"
    />
    <modal-wrapper ref="incidentFormModal">
      <incident-form-modal
        id="incidentFormModal"
        :core-entity="entityType.code"
        @incident-added="reloadSelectedOption"
      />
    </modal-wrapper>
    <modal-wrapper ref="addFileModalWrapper">
      <add-file-modal
        id="addFileModal"
        ref="addFileModal"
        :attachment-entity-type="entityType.code"
        :entities-id-array="addFileModalEntitiesIdArray"
        @attachmentsAdded="reloadSelectedOption"
      />
    </modal-wrapper>
    <modal-wrapper ref="incidentTreeModelWrapper">
      <common-incident-tree-modal />
    </modal-wrapper>
    <common-attachment-tree-modal
      v-if="attachmentTreeModalPatient"
      ref="attachmentTreeModal"
      :patient="attachmentTreeModalPatient"
      :laboratory-id="laboratoryId"
      @attachments-updated="getRowData"
    />
    <modal-wrapper ref="addFilterModal">
      <add-custom-filter-modal
        id="addFilterModal"
        @ok="onCreateCustomFilter($event)"
      />
    </modal-wrapper>
  </div>
</template>

<script>
import GridHeader from '@/components/GridHeader'
import VtGrid from '@/components/VtGrid/VtGrid'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import SearcherModule from '@/components/SearcherModule'
import archiveSideBarStore from '@/modules/archiveModule/sideBar/archiveSideBarStore'
import ModalConfirmation from '@/components/modals/ModalConfirmation'
import { isEmpty } from 'lodash'
import Encoder from '@/utils/encoder'
import archiveFilterService from '@/modules/archiveModule/services/archiveFilterService'
import TakeOutFromLaboratoryModal from '@/modules/archiveModule/views/components/TakeOutFromLaboratoryModal'
import ArchiveAddModal from '@/modules/archiveModule/views/components/ArchiveAddModal'
import ArchiveLocationSidepanel from '@/modules/archiveModule/views/components/ArchiveLocationSidepanel'
import { ArchiveDatasource } from '@/modules/archiveModule/views/grid/config/archive-datasource'
import { getColumnDefs } from '@/modules/archiveModule/views/grid/config/archive-grid.column-defs'
import { COREENTITY_VALUES } from '@/api/resources/incident/incidentServices'
import archiveService from '@/modules/archiveModule/services/archiveService'
import ScanLocationModal from '@/modules/archiveModule/views/components/ScanLocationModal'
import ModalConfirmationCheckable from '@/components/modals/ModalConfirmationCheckable'
import { PortionOperationGuardMixin } from '@/api/operations/mixins/guards/portion-operation-guard.mixin'
import { IncidentOperationGuardMixin } from '@/api/operations/mixins/guards/incident-operation-guard.mixin'
import { GridExportMixin } from '@/mixins/grid-export.mixin'
import IncidentFormModal from '@/components/incidentsModal/IncidentFormModal'
import AddFileModal from '@/components/AddFileModal'
import CommonIncidentTreeModal from '@/components/incidentsModal/CommonIncidentModalTree'
import CommonAttachmentTreeModal from '@/components/attachments/CommonAttachmentModalTree'
import GridDisplayOptions from '@/components/GridDisplayOptions'
import { SAMPLE_STATES } from '@/api/resources/entityState/sample-state'
import { PORTION_STATES } from '@/api/resources/entityState/portion-state'
import { SUBPORTION_STATES } from '@/api/resources/entityState/subportion-state'
import { IdentifierTypeScope } from '@/api/resources/common/initialization/common-initialization.dto'
import { GridUtils } from '@/shared/util/grid-utils'
import AddCustomFilterModal from '@/components/customFilter/AddCustomFilterModal'
import apiExceptionType from '@/utils/apiExceptionType'
import { commonPortionService } from '@/api/services/common/portion/common-portion.service'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'
import { ModalUtils } from '@/shared/util/modal-utils'
import { ToastUtils } from '@/shared/util/toast-utils'

export default {
    name: 'ArchiveGrid',
    components: {
        ScanLocationModal,
        GridHeader,
        VtGrid,
        GridDisplayOptions,
        SearcherModule,
        ModalConfirmation,
        TakeOutFromLaboratoryModal,
        ArchiveAddModal,
        ArchiveLocationSidepanel,
        ModalConfirmationCheckable,
        IncidentFormModal,
        CommonIncidentTreeModal,
        AddFileModal,
        CommonAttachmentTreeModal,
        AddCustomFilterModal
    },
    mixins: [
        PortionOperationGuardMixin,
        IncidentOperationGuardMixin,
        GridExportMixin
    ],
    props: {
        initMode: { type: Object, default: () => ({ value: 'compact', icon: 'fal fa-align-justify' }) },
        initSortModel: { type: Array, default: () => [] },
        initPaginator: { type: Object, default: null },
        initTabId: { type: Number, default: 0 }
    },
    data() {
        return {
            displayOptionsUiComponent: 'uicomponent.archive.archiveGrid',
            pageSize: this.initPaginator ? this.initPaginator.size : 20,
            rowData: [],
            mode: this.initMode,
            rowModel: AgGridRowModelType.SERVER_SIDE,
            newClientSideOption: false,
            columnDefs: [],
            gridApi: null,
            columnApi: null,
            sideBarState: archiveSideBarStore.state,
            options: [
                { value: 'compact', icon: 'fal fa-align-justify' },
                { value: 'normal', icon: 'fal fa-bars' }
            ],
            encoder: new Encoder(),
            selectedRows: [],
            nextElementToConfirmTakeOut: {},
            restOfElementsToConfirmTakeOut: [],
            confirmedElementsToTakeOut: [],
            elementsNotPendingToBeUnarchived: [],
            sidePanel: false,
            COREENTITY_VALUES: COREENTITY_VALUES,
            addFileModalEntitiesIdArray: [],
            attachmentTreeModalPatient: null
        }
    },
    computed: {
        msgSelectedRows() {
            if (this.selectedRows.length) {
                const choice = this.selectedRows.length > 1 ? 2 : 1
                return `${this.selectedRows.length} ${this.$tc('global.selectedElements', choice)}`
            }
            return ''
        },
        laboratoryId() {
            return this.$store.getters.labId
        },
        sideBarSelectedOption() {
            return this.sideBarState.selectedOption
        },
        optionEntitySubtype() {
            return this.sideBarSelectedOption.filterParams?.entitySubtype ?? null
        },
        entityType() {
            return this.sideBarSelectedOption.task.entityType
        },
        areElementsOfSelectedOptionArchived() {
            return this.sideBarSelectedOption.task.areElementsArchived
        },
        areElementsOfSelectedOptionPendingUnarchiving() {
            return this.sideBarSelectedOption.task.areElementsPendingUnarchiving
        },
        areElementsOfSelectedOptionArchivedAndNotPendingUnarchiving() {
            return this.areElementsOfSelectedOptionArchived &&
                !this.areElementsOfSelectedOptionPendingUnarchiving
        },
        uiComponent() {
            return this.sideBarSelectedOption?.uicomponent ?? null
        },
        rowHeight() {
            if (this.mode.value === 'compact') {
                return 25
            }
            return 40
        },
        displayedColumns() {
            return this.columnApi.getAllDisplayedColumns()
        },
        sortModel() {
            return this.gridApi.getSortModel()
        },
        gridOptions() {
            return {
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged,
                onSortChanged: this.onSortChanged,
                onFilterChanged: this.onFilterChanged,
                paginationPageSize: this.pageSize,
                paginationAutoPageSize: false,
                sideBar: gridSideBarConfig,
                getContextMenuItems: this.getArchiveContextMenu,
                getRowHeight: () => this.rowHeight,
                rowModelType: this.rowModel,
                autoGroupColumnDef: {
                    headerName: 'Consoles', // custom header name for group
                    pinned: 'left', // force pinned left. Does not work in columnDef
                    cellRendererParams: {
                        suppressCount: true // remove number in Group Column
                    }
                }
            }
        }
    },
    watch: {
        sideBarSelectedOption(newValue, oldValue) {
            if (this.rowModel === AgGridRowModelType.SERVER_SIDE || !this.newClientSideOption) {
                if (newValue && newValue !== oldValue) {
                    this.rowModel = AgGridRowModelType.SERVER_SIDE
                    this.rowData = []
                }
            } else {
                this.newClientSideOption = false
            }
        }
    },
    async mounted() {
        if (this.$route.params.sidebarOption) {
            const option = archiveSideBarStore.findOptionById(this.$route.params.sidebarOption)
            archiveSideBarStore.setSelectedOption(option)
        } else {
            archiveSideBarStore.selectDefaultOption()
        }
        await archiveSideBarStore.loadCustomOptions()
    },
    methods: {
        showInGlobalLocator(label) {
            this.$eventHub.$emit('show-in-global-locator', label)
        },
        async markPortionsAsDepleted(elements) {
            const entityIds = elements.map(element => {
                return {
                    caseId: element.caseId,
                    portionId: element.id,
                    sampleId: element.sampleId
                }
            })
            const [err] = await this.toCall(commonPortionService.markPortionsAsDepleted(this.laboratoryId, entityIds, false))
            if (err) {
                if (err.response?.data?.code === apiExceptionType.MARK_AS_DEPLETED_PORTION_HAS_SUBPORTIONS_PENDING_CUT) {
                    const shouldCancelSubportionsPendingCut = await ModalUtils.showConfirmationModal(err.response.data.message)
                    if (shouldCancelSubportionsPendingCut) {
                        const [err2] = await this.toCall(commonPortionService.markPortionsAsDepleted(this.laboratoryId, entityIds, true))
                        if (err2) {
                            ModalUtils.showErrorModal(error?.response?.data?.length && error.response.data[0].errorMessage)
                            return
                        }
                    } else {
                        return
                    }
                } else {
                    ModalUtils.showErrorModal()
                    return
                }
            }
            ToastUtils.showToastSuccess(this.$tc('laboratory.content.blockMarkAsDepletedSuccessfully'))
            this.getRowData()
            this.$emit('reload-sidebar-summary')
        },
        async markPortionsAsNonDepleted(elements) {
            const entityIds = elements.map(element => {
                return {
                    caseId: element.caseId,
                    portionId: element.id,
                    sampleId: element.sampleId
                }
            })
            const [error] = await this.$_toCall(commonPortionService.markPortionsAsNonDepleted(this.laboratoryId, entityIds))
            if (error) {
                this.$_showErrorModal(error?.response?.data?.length && error.response.data[0].errorMessage)
            } else {
                ToastUtils.showToastSuccess(this.$tc('laboratory.content.blockMarkAsNonDepletedSuccessfully'))
            }
            this.getRowData()
        },
        showMarkAsDepletedContextMenuOption(elementsSelected) {
            return this.entityType.code === COREENTITY_VALUES.PORTION.code &&
                elementsSelected.some(element => !element.depleted) &&
                this.$_canMarkPortionAsDepleted()
        },
        showMarkAsNonDepletedContextMenuOption(elementsSelected) {
            return this.entityType.code === COREENTITY_VALUES.PORTION.code &&
                elementsSelected.some(element => element.depleted) &&
                this.$_canMarkPortionAsDepleted()
        },
        showAddAttachmentContextMenuOption(elementSelected) {
            return this.$_canBeAttached(elementSelected)
        },
        showCreateIncidentContextMenuOption(elementSelected) {
            return this.$_canCreateIncident() && this.$_canCreateIncidents(elementSelected)
        },
        async unarchiveSelectedElements(selectedElements) {
            this.updateLoading(true)
            const unarchiveBatchRequest = { entityIdentifiers: selectedElements.map(element => archiveService.getEntityHierarchicalIds(element)) }
            const [err, response] = await this.toCall(archiveService.unarchiveBatchPendingToBeUnarchived(this.laboratoryId, this.entityType, unarchiveBatchRequest))
            this.updateLoading(false)
            this.$emit('reload-sidebar-summary')
            if (err) {
                ModalUtils.showErrorModalFromErrorResponse(err)
            } else if (response && response.length) {
                let errorMessage = ''
                const elementsWithError = []
                response.forEach(elementWithError => {
                    const elementIndex = selectedElements.findIndex(element => element.id === elementWithError.id)
                    const selectedElement = selectedElements[elementIndex]
                    if (selectedElement) {
                        errorMessage = errorMessage + `<p>${selectedElement.label}: ${elementWithError.errorMessage}</p>`
                        elementsWithError.push(selectedElement)
                    } else {
                        errorMessage = errorMessage + `<p>${elementWithError.errorMessage}</p>`
                    }
                })
                const wasClientSide = this.rowModel === AgGridRowModelType.CLIENT_SIDE
                this.rowModel = AgGridRowModelType.CLIENT_SIDE
                this.rowData = elementsWithError
                this.gridApi.setRowData(this.rowData)
                this.gridApi.refreshCells()
                if (wasClientSide) {
                    this.gridApi.selectAll()
                }
                ModalUtils.showErrorModal(`${this.$tc('archive.error.errorUnarchiving')}: ${errorMessage}`)
            } else {
                ToastUtils.showToastSuccess(this.$tc('archive.toastMessages.selectionUnarchived'))
                this.reloadSelectedOption()
            }
        },
        onConfirmedElementToTakeOut() {
            this.confirmedElementsToTakeOut.push(this.nextElementToConfirmTakeOut)
            if (this.restOfElementsToConfirmTakeOut.length) {
                if (this.$refs.takeOutFromLaboratoryConfirmation.status) {
                    this.confirmedElementsToTakeOut = this.confirmedElementsToTakeOut.concat(this.restOfElementsToConfirmTakeOut)
                    this.takeOutConfirmedElements()
                } else {
                    this.nextElementToConfirmTakeOut = this.restOfElementsToConfirmTakeOut.shift()
                    this.$nextTick(() => this.$refs.takeOutFromLaboratoryConfirmation.show(
                        this.onConfirmedElementToTakeOut,
                        this.onNotConfirmedElementToTakeOut
                    ))
                }
            } else {
                this.takeOutConfirmedElements()
            }
        },
        onNotConfirmedElementToTakeOut() {
            if (this.restOfElementsToConfirmTakeOut.length) {
                if (this.$refs.takeOutFromLaboratoryConfirmation.status) {
                    this.takeOutConfirmedElements()
                } else {
                    this.nextElementToConfirmTakeOut = this.restOfElementsToConfirmTakeOut.shift()
                    this.$nextTick(() => this.$refs.takeOutFromLaboratoryConfirmation.show(
                        this.onConfirmedElementToTakeOut,
                        this.onNotConfirmedElementToTakeOut
                    ))
                }
            } else {
                this.takeOutConfirmedElements()
            }
        },
        takeOutConfirmedElements() {
            const batchOfElementsToTakeOut = this.elementsNotPendingToBeUnarchived.concat(this.confirmedElementsToTakeOut)
            if (batchOfElementsToTakeOut.length) {
                this.$refs.takeOutFromLaboratoryModal.show(batchOfElementsToTakeOut)
            }
            this.confirmedElementsToTakeOut = []
            this.nextElementToConfirmTakeOut = {}
            this.restOfElementsToConfirmTakeOut = []
            this.elementsNotPendingToBeUnarchived = []
            this.$refs.takeOutFromLaboratoryConfirmation.status = false
        },
        async takeOutFromLaboratorySelectedElements() {
            this.elementsNotPendingToBeUnarchived = this.selectedRows.filter(element => !element.isPendingUnarchiving)
            this.restOfElementsToConfirmTakeOut = this.selectedRows.filter(element => element.isPendingUnarchiving)
            this.nextElementToConfirmTakeOut = this.restOfElementsToConfirmTakeOut.shift()
            if (this.nextElementToConfirmTakeOut) {
                await this.$refs.takeOutFromLaboratoryConfirmation.show(
                    this.onConfirmedElementToTakeOut,
                    this.onNotConfirmedElementToTakeOut
                )
            } else {
                this.takeOutConfirmedElements()
            }
        },

        _getEntityNotFoundErrorMessage(entityType) {
            switch (entityType) {
            case COREENTITY_VALUES.SAMPLE:
                return this.$tc('component.searcher.error.noSample')
            case COREENTITY_VALUES.PORTION:
                return this.$tc('component.searcher.error.noPortion')
            case COREENTITY_VALUES.SUBPORTION:
                return this.$tc('component.searcher.error.noSubportion')
            default:
                return this.$tc('archive.error.validIdentifier')
            }
        },
        _getEntityLabId(entity, entityType) {
            switch (entityType) {
            case COREENTITY_VALUES.SUBPORTION:
                return entity?.portion?.sample.caseStudy.laboratory.labId
            case COREENTITY_VALUES.PORTION:
                return entity?.sample?.caseStudy.laboratory.labId
            case COREENTITY_VALUES.SAMPLE:
                return entity?.caseStudy?.laboratory.labId
            default:
                return null
            }
        },
        _getEntitySubtype(entity, entityType) {
            if (entityType === COREENTITY_VALUES.PORTION) {
                return entity?.portionType
            } else if (entityType === COREENTITY_VALUES.SUBPORTION) {
                return entity?.subportionType
            }
            return null
        },
        _entityIsOutOfLaboratory(entityType, statusCode) {
            switch (entityType) {
            case COREENTITY_VALUES.SAMPLE:
                return SAMPLE_STATES.OUT_OF_LABORATORY.code === statusCode
            case COREENTITY_VALUES.PORTION:
                return PORTION_STATES.OUT_OF_LABORATORY.code === statusCode
            case COREENTITY_VALUES.SUBPORTION:
                return SUBPORTION_STATES.OUT_OF_LABORATORY.code === statusCode
            default:
                return false
            }
        },
        async onEntitySearch(searchInformation, entityType) {
            const response =
                await this.$_toCallUnique(
                    archiveService.searchEntityByLabel(
                        this.laboratoryId,
                        searchInformation.search,
                        entityType),
                    error => this.$_showErrorModalFromErrorResponse(
                        error,
                        error.response.data.code === this.$apiExceptions.ENTITY_NOT_FOUND
                            ? this._getEntityNotFoundErrorMessage(entityType)
                            : undefined))

            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: entityType.code,
                            entityValue: this._parseSearchEntityValue(entity, entityType.code),
                            laboratoryId: this._getEntityLabId(entity.additionalInfo, entityType.code)
                        }))
                    const entityValueSelected =
                        await this.$_showMultiEntitySelection(searchInformation.search, foundEntities)

                    entitySelected = response.find(entity => entity.foundEntity.id === entityValueSelected.id)
                }

                const entitySubtype = this._getEntitySubtype(entitySelected.foundEntity, entityType)
                const matchingSideBarOption =
                    archiveSideBarStore.findSideBarOptionByEntityAndOperations(
                        entitySelected.foundEntity,
                        entityType,
                        entitySubtype,
                        entitySelected.executableOperations)
                if (!matchingSideBarOption ||
                    (
                        entitySelected.foundEntity.unarchivedWithReturnOption === false &&
                        this._entityIsOutOfLaboratory(entityType, entitySelected.foundEntity.status.code)
                    )
                ) {
                    this.$_showErrorModal(this._getEntityNotFoundErrorMessage(entityType))
                    return
                }

                if (this.sideBarSelectedOption === matchingSideBarOption) {
                    this.rowModel = AgGridRowModelType.CLIENT_SIDE
                    if (this.rowData.find(row => row.id === entitySelected.foundEntity.id)) {
                        this.$_showWarningModal(this.$tc('component.searcher.error.elementAlreadyAdded'))
                    } else {
                        this.rowData.push(entitySelected.foundEntity)
                        const previousNodes = this.gridApi.getRenderedNodes()
                        this.gridApi.setRowData(this.rowData)
                        if (this.rowData.length > 1) {
                            /**
                             * we only call selectAll when length != 1
                             * because this call produces an error here due to row model change
                             * we have to wait for onGridReady to do selectAll
                             */
                            this.$_keepSelectionGridWhenSearch(
                                this.gridApi,
                                entitySelected.foundEntity.id,
                                previousNodes)
                        }
                    }
                } else {
                    this.$refs.archiveOptionChangeConfirmationModal.ask(() => {
                        // on ok callback
                        archiveSideBarStore.setSelectedOption(matchingSideBarOption)
                        this.newClientSideOption = true
                        this.rowModel = AgGridRowModelType.CLIENT_SIDE
                        this.rowData = [entitySelected.foundEntity]
                        this.gridApi.setRowData(this.rowData)
                    })
                }
            }
        },
        _parseSearchEntityValue(archiveEntitySearch, entityType) {
            switch (entityType) {
            case IdentifierTypeScope.SAMPLE:
                return this._parseSearchEntityValueToSample(archiveEntitySearch)
            case IdentifierTypeScope.PORTION:
                return this._parseSearchEntityValueToPortion(archiveEntitySearch)
            case IdentifierTypeScope.SUBPORTION:
                return this._parseSearchEntityValueToSubportion(archiveEntitySearch)
            default:
                return null
            }
        },
        _parseSearchEntityValueToPortion(archiveSearchPortionResponse) {
            const additionalInfo = archiveSearchPortionResponse.additionalInfo
            const foundEntity = archiveSearchPortionResponse.foundEntity
            const caseStudy = additionalInfo.sample.caseStudy
            return {
                id: foundEntity.id,
                portionLabel: foundEntity.label,
                portionType: additionalInfo.portionType,
                sample: {
                    sampleLabel: additionalInfo.sample.sampleLabel,
                    caseStudy: {
                        casenumber: caseStudy.casenumber,
                        laboratory: caseStudy.laboratory,
                        patient: caseStudy.patient
                    }
                }
            }
        },
        _parseSearchEntityValueToSample(archiveSearchSampleResponse) {
            const additionalInfo = archiveSearchSampleResponse.additionalInfo
            const foundEntity = archiveSearchSampleResponse.foundEntity
            const caseStudy = additionalInfo.caseStudy
            return {
                id: foundEntity.id,
                sampleLabel: foundEntity.label,
                sampleType: additionalInfo.sampleType,
                topographicCode: additionalInfo.topographicCode,
                caseStudy: {
                    casenumber: caseStudy.casenumber,
                    laboratory: caseStudy.laboratory,
                    patient: caseStudy.patient
                }
            }
        },
        _parseSearchEntityValueToSubportion(archiveSearchSubportionResponse) {
            const additionalInfo = archiveSearchSubportionResponse.additionalInfo
            const portionLabel = additionalInfo.portion.portionLabel
            const sampleLabel = additionalInfo.portion.sample.sampleLabel
            const caseStudy = additionalInfo.portion.sample.caseStudy
            const assay = additionalInfo.assay
            return {
                id: archiveSearchSubportionResponse.foundEntity.id,
                subportionLabel: archiveSearchSubportionResponse.foundEntity.label,
                portion: {
                    portionLabel: portionLabel,
                    sample: {
                        sampleLabel: sampleLabel,
                        caseStudy: {
                            casenumber: caseStudy.casenumber,
                            laboratory: caseStudy.laboratory,
                            patient: caseStudy.patient
                        }
                    }
                },
                assay: assay
            }
        },
        closeArchiveLocationSidepanel(value) {
            this.sidePanel = value
        },
        async cancelShipping() {
            await ModalUtils.showConfirmationModal(`${this.$tc('shipments.modal.cancelConfirmation')} ${this.selectedRows.length} ${this.$tc('configuration.grid.element', this.selectedRows.length)}, <br/> ${this.$tc('shipments.modal.cancelQuestion')}`, this.$tc('shipments.actions.cancelShipping'))
        },
        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        onSortChanged({ api }) {
            api.deselectAll()
        },
        onFilterChanged({ api }) {
            api.deselectAll()
        },
        getArchiveContextMenu(params) {
            if (!params?.node) {
                return []
            }
            const elements = this.selectedRows.length ? this.selectedRows : [params?.node.data]
            return [
                {
                    name: this.$t('archive.actions.archive'),
                    cssClasses: !this.areElementsOfSelectedOptionArchived ? '' : ['not-show'],
                    action: () => this.$refs.archiveAddModal.show(elements)
                },
                {
                    name: this.$t('archive.actions.remove'),
                    cssClasses: this.areElementsOfSelectedOptionPendingUnarchiving ? '' : ['not-show'],
                    action: () => this.unarchiveSelectedElements(elements)
                },
                {
                    name: this.$t('archive.actions.editArchiveLocation'),
                    cssClasses: this.areElementsOfSelectedOptionArchived && elements.length === 1 ? '' : ['not-show'],
                    action: () => {
                        this.$refs.scanLocationModalWrapper.show(elements)
                    }
                },
                {
                    name: this.$t('grid.detail.markAsDepleted'),
                    action: () => this.markPortionsAsDepleted(elements),
                    cssClasses: this.showMarkAsDepletedContextMenuOption(elements) ? '' : ['not-show']
                },
                {
                    name: this.$t('grid.detail.markAsNonDepleted'),
                    action: () => this.markPortionsAsNonDepleted(elements),
                    cssClasses: this.showMarkAsNonDepletedContextMenuOption(elements) ? '' : ['not-show']
                },
                {
                    name: this.$t('archive.actions.registerIncident'),
                    action: () => this.openIncidentForm(elements[0]),
                    cssClasses: elements.length === 1 && this.showCreateIncidentContextMenuOption(elements[0]) ? '' : ['not-show']
                },
                {
                    name: this.$t('archive.actions.addAttachment'),
                    action: () => this.showAddFileModal(elements[0]),
                    cssClasses: elements.length === 1 && this.showAddAttachmentContextMenuOption(elements[0]) ? '' : ['not-show']
                },
                {
                    name: this.$t('archive.actions.viewIncidents'),
                    action: () => this.showIncidentTreeModal(elements[0]),
                    cssClasses: elements.length === 1 ? '' : ['not-show']
                },
                {
                    name: this.$t('archive.actions.viewAttachments'),
                    action: () => this.showAttachmentTreeModal(elements[0]),
                    cssClasses: elements.length === 1 ? '' : ['not-show']
                },
                {
                    name: this.$t('global.showInGlobalLocator'),
                    action: () => this.showInGlobalLocator(elements[0].label),
                    cssClasses: elements.length === 1 ? '' : ['not-show']
                }
            ]
        },
        openIncidentForm(element) {
            const hierarchicalIds = archiveService.getEntityHierarchicalIdsForIncidentModal(element)
            this.$refs.incidentFormModal.show([null, hierarchicalIds])
        },
        showAddFileModal(element) {
            const hierarchicalIds = archiveService.getEntityHierarchicalIds(element)
            this.addFileModalEntitiesIdArray = [this.laboratoryId, ...Object.values(hierarchicalIds)]
            this.$refs.addFileModalWrapper.show()
        },
        showIncidentTreeModal(element) {
            const elementToFocusOn = archiveService.getEntityHierarchicalIdsForIncidentModal(element)
            elementToFocusOn.coreEntity = this.entityType.code
            this.$refs.incidentTreeModelWrapper.show([elementToFocusOn, element.patientId])
        },
        showAttachmentTreeModal(element) {
            this.attachmentTreeModalPatient = { patId: element.patientId }
            this.$nextTick(() => {
                switch (this.entityType) {
                case COREENTITY_VALUES.SAMPLE:
                    return this.$refs.attachmentTreeModal.showSample(element.id)
                case COREENTITY_VALUES.PORTION:
                    return this.$refs.attachmentTreeModal.showPortion(element.id)
                case COREENTITY_VALUES.SUBPORTION:
                    return this.$refs.attachmentTreeModal.showSubportion(element.id)
                }
            })
        },
        onGridReady(event) {
            this.gridApi = event.api
            this.columnApi = event.columnApi

            this.gridApi.setColumnDefs(getColumnDefs(this.sideBarSelectedOption.task.id))
            if (this.rowModel === AgGridRowModelType.SERVER_SIDE) {
                this.searchActive = false
                this.getRowData()
            } else {
                this.gridApi.setRowData(this.rowData)
                this.gridApi.selectAll()
            }
        },
        getRowData() {
            if (this.gridApi && this.sideBarSelectedOption) {
                this.gridApi.deselectAll()

                if (!isEmpty(this.sideBarSelectedOption.filterModel)) {
                    this.gridApi.setFilterModel(this.sideBarSelectedOption.filterModel)
                } else if (isEmpty(this.sideBarSelectedOption.filterModel) && !isEmpty(this.gridApi.getFilterModel())) {
                    this.gridApi.setFilterModel(null)
                }

                this.gridApi.setServerSideDatasource(
                    new ArchiveDatasource(
                        this.laboratoryId,
                        this.sideBarSelectedOption.task.url,
                        this.sideBarSelectedOption.filterParams))
            }
        },
        changedMode(selectedOption) {
            this.mode = selectedOption
            GridUtils.changeRowHeightGrid(this.gridApi, selectedOption.size)
        },
        changedPageSize(pageSize) {
            this.pageSize = pageSize
            this.gridApi.paginationSetPageSize(pageSize)
        },
        cleanFilters() {
            if (this.gridApi) {
                this.gridApi.setFilterModel(null)
            }
            if (this.columnApi) {
                this.columnApi.resetColumnState()
            }
        },

        exportReport(exportType) {
            const columns = this.$_getColumnsToExport(this.gridApi, this.columnApi)
            if (columns && this.gridApi) {
                return archiveFilterService.exportTo(
                    this.laboratoryId,
                    this.$tc(this.sideBarState.selectedOption.label),
                    this.encoder.parseBooleans(this.gridApi.getFilterModel()),
                    GridUtils.getSortValue(this.sortModel),
                    columns,
                    this.selectedRows.map(archiveService.getEntityHierarchicalIds),
                    this.sideBarSelectedOption.task.url,
                    this.sideBarSelectedOption.filterParams?.entitySubtype,
                    exportType)
            }
            return null
        },

        onAddCustomFilter() {
            this.$refs.addFilterModal.show()
        },
        async onCreateCustomFilter(option) {
            const filter = {
                filterName: option.label,
                filterCriteria: {
                    filterModel: this.gridApi.getFilterModel(),
                    filterParams: this.sideBarSelectedOption.filterParams,
                    uicomponent: this.sideBarState.componentCode,
                    task: this.sideBarSelectedOption.task
                }
            }
            if (await archiveSideBarStore.createCustomOption(filter)) {
                ToastUtils.showToastSuccess(this.$tc('global.filterAdded'))
            }
        },
        async onUpdateCustomFilter(customFilter) {
            const filter = {
                ...customFilter,
                filterCriteria: {
                    ...customFilter.filterCriteria,
                    filterModel: this.gridApi.getFilterModel(),
                    filterParams: this.sideBarSelectedOption.filterParams,
                    uicomponent: this.sideBarState.componentCode,
                    task: this.sideBarSelectedOption.task
                }
            }
            if (await archiveSideBarStore.updateCustomOption(filter)) {
                ToastUtils.showToastSuccess(this.$tc('global.filterUpdated'))
            }
        },

        onArchived() {
            this.reloadSelectedOption()
            this.$emit('reload-sidebar-summary')
        },
        onElementsTakenOutFromLaboratory() {
            this.reloadSelectedOption()
            this.$emit('reload-sidebar-summary')
        },
        reloadSelectedOption() {
            this.rowModel = AgGridRowModelType.SERVER_SIDE
            this.rowData = []
            this.getRowData()
        },
        async onLocationUpdated(entity) {
            const idHierarchy = archiveService.getEntityHierarchicalIds(entity)
            const updateLocationRequest = {
                idHierarchy,
                id: entity.id,
                label: entity.label,
                archivingLocation: entity.archivingLocation
            }
            this.updateLoading(true)
            const [error] = await this.toCall(archiveService.updateArchivingLocation(this.laboratoryId, this.entityType, updateLocationRequest))
            this.updateLoading(false)
            if (error) {
                ModalUtils.showErrorModalFromErrorResponse(error)
            }
            this.gridApi.purgeServerSideCache()
        }
    }
}
</script>

<style lang="scss">
.archive-module .archive-location-sidepanel {
    background: #FFF;
    width: 300px;
    position: absolute;
    right: 0;
    top: 0;
    height: calc(100% - 32px);
    z-index: 4;
    box-shadow: -5px 0 5px -5px #b2b2b2;
    border: 1px solid vt-color(grid-general-border);
}

.archive-module .archive-location-sidepanel .title {
    color: vt-color(primary);
}

.archive-module .archive-grid {
  height: 100%;
}

.archive-module .vertical-line {
    height: 10px;
    width: 1px;
    background: vt-color(base-text, 0.6);
}

.archive-module .sr-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.5rem;
  flex-shrink: 0;
}

.archive-module .sr-header-buttons {
  margin-right: 1.5em;
}

.archive-module .barcode-input {
    border: 1px solid vt-color(grid-general-border);
    border-radius: 5px;
    height: 26px;
}

.archive-module .barcode-input > div,
.archive-module .barcode-input .input-group {
    height: 100%;
}

.archive-module .input-group-prepend .input-group-text {
    height: 100%;
    padding: 0 0.55rem;
    border-radius: 14px;
    color: vt-color(search-bar-text);
    border: none;
    background-color: inherit;
    font-size: 12px;
}

.archive-module .barcode-input input {
    padding: 0;
    background: transparent;
    border-color: transparent;
    height: 100%;
}

</style>
